import React from "react";
import { WithRoleAccess } from "@services/ui-components";
import { Link } from "react-router-dom";
import { CompanyAccess, ReviewProxy } from "@me-team/host/main/graphql/types";

interface RenderClientNameProps {
    review: ReviewProxy;
    currentCompanyId?: string | number;
    branchId?: string | number;
}

const RenderClientName: React.FC<RenderClientNameProps> = ({ review, currentCompanyId, branchId }) => {
    const clientName = (
        <>
            {review?.booking?.client?.name} {review?.booking?.client?.surname} ({review?.name})
        </>
    );

    return (
        <>
            {review?.booking ? (
                <WithRoleAccess permission={CompanyAccess.ClientListView} fallback={<span>{clientName}</span>}>
                    <Link
                        className="text-dark text-decoration-none"
                        to={`/clients/${currentCompanyId}/list/${review?.booking?.client?.id}/edit/${branchId}`}
                    >
                        {clientName}
                    </Link>
                </WithRoleAccess>
            ) : (
                <span>{review?.name}</span>
            )}
        </>
    );
};

export default RenderClientName;
